import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface GeneralInfoRowProps {
    label: string
    value: string
}

const GeneralInfoRow: FC<GeneralInfoRowProps> = ({ label, value }) => {
    return (
        <View style={styles.row}>
            <Typography.Description style={styles.rowLabel}>{label}</Typography.Description>
            <Typography.Description font="medium" style={styles.rowValue}>
                {value}
            </Typography.Description>
        </View>
    )
}

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        columnGap: 8,
        rowGap: 4,
    },
    rowLabel: {
        color: ColorEnum.GRAY_600,
    },
    rowValue: {
        color: ColorEnum.GRAY_900,
    },
})

export default GeneralInfoRow
